import * as types from '../types/contentTypes';

const initialState = {
  pages: {},
  loading: false,
  error: null,
};

function cacheKey(contentKey, locale) {
  return `${contentKey}_${locale}`;
}

export default function contentReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_CONTENT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.GET_CONTENT_SUCCESS: {
      const { contentKey, locale, data } = action.payload || {};
      if (!contentKey || !locale) return { ...state, loading: false };
      return {
        ...state,
        loading: false,
        error: null,
        pages: {
          ...state.pages,
          [cacheKey(contentKey, locale)]: data || null,
        },
      };
    }
    case types.GET_CONTENT_FAILURE:
      return { ...state, loading: false, error: action.payload?.message || action.payload || 'Failed' };
    default:
      return state;
  }
}
